import { Navigate, Route, Routes } from "react-router";
import { Protected } from "../protected";
import { CustomerContractDetails } from "./customer-contract-details";
import { CustomerContractNotes } from "./customer-contract-notes";
import { CustomerContractAttachments } from "./customer-contract-attachments";
import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "../sidebar";
import { getCustomerContractSidebarContent } from "./sidebar-content";
import { IContract, ICustomer } from "@river/interfaces";
import { ContractContext } from "./contract.context";
import { useNotification } from "@river/common-ui";
import { customerService } from "../../services";

interface IProps {
  customer: ICustomer;
}

export const CustomerContract = ({ customer }: IProps) => {
  const notify = useNotification();
  const [contract, setContract] = useState<IContract | null>(null);
  const sidebarContext = useContext(SidebarContext);

  async function fetchContract() {
    try {
      const data = await customerService.getCustomerContracts(customer._id);
      if (data.length > 0) {
        setContract(data[0]);
      }
    } catch (message) {
      notify.error({ message });
    }
  }

  useEffect(() => {
    if (customer) {
      // sidebarContext?.setSidebarContent(
      //   getCustomerContractSidebarContent(customer)
      // );

      fetchContract();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <ContractContext.Provider
        value={{ contract, setContract, fetchContract }}
      >
        <Routes>
          <Route path="/*" element={<Navigate to="details" />} />
          <Route
            path="/details"
            element={
              <Protected>
                <CustomerContractDetails />
              </Protected>
            }
          />
          <Route
            path="/notes"
            element={
              <Protected>
                <CustomerContractNotes />
              </Protected>
            }
          />
          <Route
            path="/attachments"
            element={
              <Protected>
                <CustomerContractAttachments />
              </Protected>
            }
          />
        </Routes>
      </ContractContext.Provider>
    </>
  );
};
